import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="flash"
export default class extends Controller {
  static values = {
    timeout: Number,
  };

  connect() {
    // Set a timeout to remove the flash message
    setTimeout(() => {
      this.element.style.opacity = "0";
      this.element.style.transition = "opacity 0.5s ease-out";

      // Remove the element after fade out
      setTimeout(() => {
        this.element.remove();
      }, 500);
    }, this.timeoutValue);
  }
}
